module.exports = __webpack_public_path__ + "static/img/vd-buy.6c69fc64.png";